import { p as pipe } from '../ReadonlyNonEmptyArray-0e481d0b.js';
import { Node_Type } from 'ricos-schema';
import { getModifier } from '../modifier-infra.js';
import '../Either-48abb652.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';
import '../string-40bcd6bf.js';
import '../converters/generateRandomId.js';
import 'lodash';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const nodesAccessor = (node) => {
  var _a;
  return (_a = node.nodes) != null ? _a : [];
};
const nodesSetter = (nodes) => ({ nodes });
const getRootNode = (content) => ({
  id: "root",
  type: Node_Type.UNRECOGNIZED,
  nodes: content.nodes
});
const toRichContentModifier = (content) => function(modifier) {
  const self = { modifier };
  return {
    filter(predicate) {
      self.modifier = modifier.filter.bind(self.modifier)(predicate);
      self.modifier.set = this.set;
      self.modifier.filter = this.filter;
      return self.modifier;
    },
    set(setter) {
      const root = modifier.set.bind(self.modifier)(setter);
      return __spreadProps(__spreadValues({}, content), { nodes: root.nodes });
    }
  };
};
const modify = (content) => pipe(
  content,
  getRootNode,
  getModifier(nodesAccessor, nodesSetter),
  toRichContentModifier(content)
);

export { modify };
//# sourceMappingURL=modify.js.map
